var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"download":decodeURI(_vm.fileName),"target":_vm.blankOrDirect,"href":_vm.fileUrl}},[_vm._v("\n    "+_vm._s(decodeURI(_vm.fileName))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }